// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3dqqB","col":"styles_col__3dDME"};